module.exports = __webpack_public_path__ + "static/media/logo.778eb257.png";